import { render, staticRenderFns } from "./full-page-dialog.component.vue?vue&type=template&id=0cf4dea8&scoped=true"
import script from "./full-page-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./full-page-dialog.component.ts?vue&type=script&lang=ts&external"
import style0 from "./full-page-dialog.component.vue?vue&type=style&index=0&id=0cf4dea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf4dea8",
  null
  
)

export default component.exports